module.exports = __webpack_public_path__ + "static/media/Big_green_sapphire.0c2a82cd.png";